module.exports = __webpack_public_path__ + "img/arc-legal-logo.b52072b8.png";